import {
  GET_ALL_VENDOR_EVENTS_PAGINATED_ERROR,
  GET_ALL_VENDOR_EVENTS_PAGINATED_SUCCESS,
  SET_LOADING,
  SET_PAGINATION_DATA,
} from './actionTypes';

const initialState = {
  events: [],
  pagination: {
    count: 10,
    total: 0,
    page: 1,
    pageCount: 0,
    search: '',
  },
  error: null,
  loading: false,
};

// eslint-disable-next-line default-param-last
const vendorEventsPaginatedReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_VENDOR_EVENTS_PAGINATED_SUCCESS:
      return {
        ...state,
        events: action.payload.data,
        pagination: action.payload.paginationData,
        loading: false,
        error: null,
      };
    case GET_ALL_VENDOR_EVENTS_PAGINATED_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SET_PAGINATION_DATA:
      return {
        ...state,
        pagination: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default vendorEventsPaginatedReducer;
